import {SnackbarActions} from "../../../store/snackbar";
import {Component} from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogContentText,
    Button
} from "@mui/material"
import {ApplicationState} from "../../../store/root.types";
import {connect} from "react-redux";
import {WithTranslation, withTranslation} from "react-i18next";

interface IProps {
    readonly open: boolean
    readonly title: string
    readonly message: string
    readonly to?: string

    onCloseDialog: () => void
}

type Props = IProps & WithTranslation

class DialogComponent extends Component<Props> {

    public render() {
        const {
            open,
            message,
            title,
            to,
            onCloseDialog,
        } = this.props

        const handleClose = () => {
            onCloseDialog()
            if (to) {
                window.location.href = to
            }
        }

        return <Dialog
            open={open}
            onClose={() => {}}
            disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={handleClose} variant='contained' autoFocus>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    open: state.snackbar.dialog.open,
    title: state.snackbar.dialog.title,
    message: state.snackbar.dialog.message,
    to: state.snackbar.dialog.to,
})

const DialogTranslations: any = withTranslation()(DialogComponent)

export default connect(mapStateToProps, SnackbarActions)(DialogTranslations)

